import { render } from "./ExpireList.vue?vue&type=template&id=5f37ced0"
import script from "./ExpireList.vue?vue&type=script&lang=js"
export * from "./ExpireList.vue?vue&type=script&lang=js"

import "./ExpireList.vue?vue&type=style&index=0&id=5f37ced0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__